export default __webpack_public_path__ + "src/assets/fonts/KievitPro-Regular.eot";